var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnackbarError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.6875C5.30454 0.6875 0.6875 5.30454 0.6875 11C0.6875 16.6955 5.30454 21.3125 11 21.3125C16.6955 21.3125 21.3125 16.6955 21.3125 11C21.3125 5.30454 16.6955 0.6875 11 0.6875ZM11 19.9375C6.07187 19.9375 2.0625 15.9281 2.0625 11C2.0625 6.07187 6.07187 2.0625 11 2.0625C15.9281 2.0625 19.9375 6.07187 19.9375 11C19.9375 15.9281 15.9281 19.9375 11 19.9375ZM11 7.90625C11.5695 7.90625 12.0312 7.44459 12.0312 6.875C12.0312 6.30549 11.5695 5.84375 11 5.84375C10.4305 5.84375 9.96875 6.30549 9.96875 6.875C9.96875 7.44459 10.4305 7.90625 11 7.90625ZM13.0625 15.125H11.6875V10.3125C11.6875 9.93248 11.38 9.625 11 9.625H9.625C9.24498 9.625 8.9375 9.93248 8.9375 10.3125C8.9375 10.6925 9.24498 11 9.625 11H10.3125V15.125H8.9375C8.55783 15.125 8.25 15.4327 8.25 15.8125C8.25 16.1922 8.55783 16.5 8.9375 16.5H13.0625C13.4422 16.5 13.75 16.1922 13.75 15.8125C13.75 15.4327 13.4422 15.125 13.0625 15.125Z",
    fill: "#179BD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackbarError);
export default __webpack_public_path__ + "static/media/Snackbar-error.09bed0ba3d2eecd2c8efefbbcde71155.svg";
export { ForwardRef as ReactComponent };